import type { ProducttypeFunnelStatusCounts } from '@/api/topics/types'

/** Gesamtstatus eines Produkttyps, aus den Themenzahlen des Backends abgeleitet. */
export type FunnelStatus = 'Open' | 'Partial' | 'Complete' | 'Ignored'

/**
 * Leitet den Gesamtstatus eines Hauptrichters aus den Statuszahlen ab, die
 * der Funnel-Endpunkt bereits mitliefert.
 *
 * Ignorieren ist eine bewusste Entscheidung. Sobald kein offenes Thema
 * bleibt, ist der Produkttyp deshalb vollständig bearbeitet, auch wenn
 * neben freigegebenen Themen ignorierte Themen vorkommen. Nur ein reiner
 * Ignoriert-Block bekommt den eigenen Status "Ignored".
 */
export function deriveFunnelStatus(counts: ProducttypeFunnelStatusCounts): FunnelStatus {
  if (counts.total > 0 && counts.ignored === counts.total) return 'Ignored'
  if (counts.open > 0 && counts.approved === 0) return 'Open'
  if (counts.open === 0) return 'Complete'
  return 'Partial'
}
